<template>
  <div>
    <Head />

    <div class="wrapper home">
      <svg class="bg"></svg>

      <!-- banner -->
      <section class="banner" v-if="HomeData && HomeData.Slide_Category">
        <div class="container">
          <slick class="marquee" :options="{
            autoplay: true,
            autoplaySpeed: 5000,
          }">
            <div class="box" v-for="Post in HomeData.Slide_Category.Posts" :key="Post.PId">
              <img :src="HomeData.SiteUrl + Post.Image" alt="">
            </div>
          </slick>
        </div>
      </section>

      <section class="apply" v-if="HomeData">
        <div class="container">
          <div class="title">
            <h1>{{ HomeData.Season ? HomeData.Season.Name : $t('申請項目') }}</h1>
          </div>
          <ul class="list">
            <li v-if="HomeData.Season && HomeData.Season.Apply_1">
              <router-link class="bg_box" :to="{ name: 'Apply_1' }">
                <div class="img_box">
                  <img src="img/icon_1.svg" alt="">
                </div>
                <p>{{ $t('職務宿舍') }}<br class="br">{{ $t('申請') }}</p>
              </router-link>
            </li>
            <li v-else>
              <a href="javascript:alert('非開放時間')" class="bg_box">
                <div class="img_box">
                  <img src="img/icon_1.svg" alt="">
                </div>
                <p>{{ $t('職務宿舍') }}<br class="br">{{ $t('申請') }}(非開放時間)</p>
              </a>
            </li>
            <li>
              <router-link class="bg_box" :to="{ name: 'Building' }">
                <div class="img_box">
                  <img src="img/icon_2.svg" alt="">
                </div>
                <p>{{ $t('學人宿舍') }}<br class="br">{{ $t('申請') }}</p>
              </router-link>
            </li>
            <li v-if="HomeData.Season">
              <a href="javascript:void(0)" class="bg_box" @click="gotoApply3TypeCheck()" v-if="isLogin">
                <div class="img_box">
                  <img src="img/icon_3.svg" alt="">
                </div>
                <p>{{ $t('停車位') }}<br class="br">{{ $t('申請') }}</p>
              </a>
              <a href="" class="bg_box" data-bs-toggle="modal" data-bs-target="#parking_box" v-else>
                <div class="img_box"><img src="img/icon_3.svg" alt=""></div>
                <p>{{ $t('停車位') }}<br class="br">{{ $t('申請') }}</p>
              </a>
            </li>
            <li v-else>
              <a href="javascript:alert('非開放時間')" class="bg_box">
                <div class="img_box">
                  <img src="img/icon_3.svg" alt="">
                </div>
                <p>{{ $t('停車位') }}<br class="br">{{ $t('申請') }}(非開放時間)</p>
              </a>
            </li>
          </ul>
        </div>
      </section>

      <!-- 最新消息 -->
      <section class="news" v-if="HomeData && HomeData.News_Category">
        <div class="container">
          <div class="title">
            <h1>{{ HomeData.News_Category.Category.CategoryName }}</h1>
          </div>
          <ul class="list">
            <li v-for="Post in HomeData.News_Category.Posts" :key="Post.PId">
              <a href="javascript:void(0)" class="text" @click="gotoPost(Post)">
                <p class="time">{{ Post.PublicStartTime | timeString("YYYY-MM-DD") }}</p>
                <p>{{ Post.Title }}</p>
              </a>
            </li>
            <div class="more_btn">
              <button class="more" @click="gotoCategoryByCId(HomeData.News_Category.Category.CId)">MORE</button>
            </div>
          </ul>
        </div>
      </section>

      <!-- 照片輪播 -->
      <section class="photo" v-if="HomeData && HomeData.Photo_Category">
        <div class="container">
          <div class="btn_box">
            <button class="btn" :class="PhotoCId == Category.Category.CId ? 'active' : ''"
              v-for="Category in HomeData.Photo_Category" :key="Category.Category.CId"
              @click="PhotoCId = Category.Category.CId">
              <p>{{ Category.Category.CategoryName }}</p>
            </button>
          </div>
          <div class="list_box">
            <div class="list" :class="PhotoCId == Category.Category.CId ? 'show' : ''"
              v-for="Category in HomeData.Photo_Category" :key="Category.Category.CId">
              <slick class="carousel" :options="{
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                  {
                    breakpoint: 991.98,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                    }
                  },
                  {
                    breakpoint: 767.98,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    }
                  }
                ]
              }">
                <div class="box" v-for="Post in Category.Posts" :key="Post.PId">
                  <div class="img_box">
                    <img :src="HomeData.SiteUrl + Post.Image" alt="">
                  </div>
                  <p>{{ Post.Title }}</p>
                </div>
              </slick>
            </div>
          </div>
        </div>
      </section>

    </div><!-- wrapper -->

    <div class="modal fade parking_box" id="parking_box" tabindex="-1" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <p>請選擇身分</p>
          <ul class="btn_box">
            <li><button class="login_btn" @click="login()">教職員工或學生登入</button></li>
            <li><button class="login_btn" @click="gotoApply3()">退休教職員工登入</button></li>
          </ul>
          <div class="return_box">
            <button class="return_btn" data-bs-dismiss="modal">返回</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "申請項目": "申請項目",
    "職務宿舍": "職務宿舍",
    "申請": "申請",
    "學人宿舍": "學人宿舍",
    "停車位": "停車位",
    "退休教師申請": "退休教師申請",
    "請輸入證件號碼進行確認": "請輸入證件號碼進行確認",
    "送出": "送出",
    "取消": "取消",
    "請輸入證件號碼後再按下送出": "請輸入證件號碼後再按下送出",
    "錯誤": "錯誤",
    "確定": "確定",
  },
  en: {
    "申請項目": "Application Selection",
    "職務宿舍": "Faculty & Staff Dormitory",
    "申請": "Apply",
    "學人宿舍": "Visiting Scholars Dormitory",
    "停車位": "Parking Space",
    "退休教師申請": "Retired Faculty Application",
    "請輸入證件號碼進行確認": "Please enter the identification number for verification",
    "送出": "Submit",
    "取消": "Cancel",
    "請輸入證件號碼後再按下送出": "Please submit after entering identification number",
    "錯誤": "Error",
    "確定": "Confirm",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Home",
  i18n,
  components: {
    Head,
    Footer,
    Slick,
  },
  data() {
    return {
      HomeData: {},
      PhotoCId: -1,
      local: "zh_tw",
      isLogin: $cookies.isKey('dormitory_login_token'),
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Home",
        {
          params: {
            lang: $cookies.get("dormitory_site_lang")
          },
        }
      )
      .then((response) => {
        this.HomeData = response.data;
        this.PhotoCId = this.HomeData.PhotoCId;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId },
        });
      }
    },
    gotoCategoryByCId: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    gotoApply3() {
      $("#parking_box").modal('hide');
      let that = this;
      if (!$cookies.isKey("dormitory_login_token")) {
        Swal.fire({
          title: that.$t("退休教師申請"),
          text: that.$t("請輸入證件號碼進行確認"),
          icon: "info",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: that.$t("送出"),
          cancelButtonText: that.$t("取消"),
          input: "text",
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (!value) {
                resolve(that.$t("請輸入證件號碼後再按下送出"));
              } else {
                resolve();
              }
            });
          },
          heightAuto: false,
        })
          .then((result) => {
            if (result.isConfirmed) {
              $.ajax({
                url:
                  that.$store.state.src +
                  that.$store.state.subDirectory +
                  "/Html/CheckIdentityNumber",
                type: "post",
                data: {
                  IdentityNumber: result.value
                },
                dataType: "json",
                error: function () { },
                success: function (res) {
                  if (res.ok) {
                    $cookies.set("dormitory_nologin_token", res.LoginToken, "1h");
                    that.gotoApply3TypeCheck();
                  } else if (res.error) {
                    Swal.fire({
                      title: that.$t("錯誤"),
                      text: res.error,
                      icon: "error",
                      allowOutsideClick: false,
                      confirmButtonText: that.$t("確定"),
                      heightAuto: false,
                    });
                  }
                }
              });
            }
          });
      } else {
        this.gotoApply3TypeCheck();
      }
    },
    gotoApply3TypeCheck() {
      let that = this;
      if (that.HomeData.Season && that.HomeData.Season.Apply_3) {
        Swal.fire({
          heightAuto: false,
          title: that.$t("請選擇申請地點"),
          allowOutsideClick: false,
          confirmButtonText: that.$t("化南新村"),
          showCancelButton: true,
          cancelButtonText: "取消",
          showDenyButton: true,
          denyButtonText: that.$t("南苑地下"),
        }).then((result) => {
          if (result.isConfirmed) {
            $cookies.set("dormitory_apply_park", "化南新村", "6h");
            this.$router.push({
              name: "Apply_3"
            });
          } else if (result.isDismissed) {

          } else {
            $cookies.set("dormitory_apply_park", "南苑地下", "6h");
            this.$router.push({
              name: "Apply_3"
            });
          }
        });
      } else {
        $cookies.set("dormitory_apply_park", "南苑地下", "6h");
        this.$router.push({
          name: "Apply_3"
        });
      }
    },
    login: function () {
      location.href = this.$store.state.loginPage;
      // this.$router.push({
      //   name: "Login",
      //   query: {
      //     staNum: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC2pnx23J3Rme7Ck8LIynYW5E=',
      //     staName: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC7Z/PJvmP+8L13feSeMD8Np4BcSAl54cBbdJ7PQGecOQGSYN8='
      //   }
      // });
    },
  },
};
</script>
